import Header from "@/shared/Header";
import Footer from "@/shared/Footer";
import Analitics from "@/shared/Analitics";
import DfpSection from "@/shared/DFP/Section";
import Banner from "@/widgets/Banner/Templates/Banner";
import BannerFlotante from "@/widgets/Banner/Templates/BannerFlotante";
import { BannerFlotante2, BannerCajaGris } from "@/shared/ContentBanner";
import LdjsonOrg from "@/shared/Schemas/Organization";
import LdjsonCollectionPage from "@/shared/Schemas/CollectionPage";
import LdjsonItemList from "@/shared/Schemas/ItemList";
import LdjsonBreadcrumbList from "@/shared/Schemas/BreadcrumbList";
import LdjsonNewsMediaOrg from "@/shared/Schemas/NewsMediaOrganization";
import LdjsonWebsite from "@/shared/Schemas/Website";
import { MetaTagsSubhome } from "@/shared/MetaTags";
import Autorefresh from "@/shared/Autorefresh";
import { ContentTitleTag } from "./styles";
import { ContainerAutoList } from "@/shared/ContainerAutoList";
import Listado4Columns from "@/shared/Layout/Listado4Columns";
import Meter from "@/shared/Meter/index.jsx";
import LinkPreconnect from "@/shared/LinkPreconnect";
import { TagsRelated, TagDescription } from "./components";
import TemplateProvider from "@/context/Template/TemplateProvider.jsx";
import { useTag } from "./hooks/useTag";

const Tag = (props) => {

  const { formatContent, ...rest } = useTag(props);

  return (
    <TemplateProvider data={{ ...rest, content: formatContent }} >
      <MetaTagsSubhome />
      <LdjsonOrg />
      <LdjsonCollectionPage />
      <LdjsonItemList />
      <LdjsonBreadcrumbList />
      <LdjsonNewsMediaOrg />
      <LdjsonWebsite />
      <Analitics />
      <DfpSection />
      <Header />
      <LinkPreconnect />
      <BannerFlotante isPreview={rest?.preview} slotId={"1"} />
      <BannerFlotante isPreview={rest?.preview} slotId={"6"} />
      <ContentTitleTag>
        <ContainerAutoList>
          <p className="tag-label">Tag</p>
          <div className="tag-container">            
            <TagDescription />
            <TagsRelated />
          </div>
        </ContainerAutoList>
      </ContentTitleTag>
      <Listado4Columns />
      <BannerFlotante2>
        <BannerFlotante isPreview={rest?.preview} slotId={"2"} />
      </BannerFlotante2>
      <Autorefresh timerRefresh={600} />
      <BannerCajaGris>
        <Banner slotId={"horizontal3"} adsPath={formatContent?.adsPath} />
      </BannerCajaGris>
      <Meter />
      <Footer />
    </TemplateProvider>
  );
};

export default Tag;
